import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('graamcart_admin_token');
  if (token && config.url.includes('/admin')) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// API functions
export const seedData = () => api.post('/seed');

export const getCategories = () => api.get('/categories');

export const getProducts = (params) => api.get('/products', { params });

export const getProductsByCategory = (categorySlug) => 
  api.get(`/products/category/${categorySlug}`);

export const getProduct = (productId) => api.get(`/products/${productId}`);

export const getPopularProducts = (limit = 8) => api.get('/products/popular/list', { params: { limit } });

export const calculateCart = (items) => api.post('/cart/calculate', items);

export const createOrder = (orderData) => api.post('/orders', orderData);

export const getOrder = (orderId, token) =>
  api.get(`/orders/${orderId}`, { params: token ? { token } : {} });

export const adminGetOrderFull = (orderId) => api.get(`/admin/orders/${orderId}`);

export const adminGetOrdersByPhone = (phone) => api.get(`/admin/orders/by-phone/${phone}`);

// Admin APIs
export const adminLogin = (credentials) => api.post('/admin/login', credentials);

export const adminGetProducts = () => api.get('/admin/products');

export const adminCreateProduct = (product) => api.post('/admin/products', product);

export const adminUpdateProduct = (productId, data) => 
  api.put(`/admin/products/${productId}`, data);

export const adminDeleteProduct = (productId) => 
  api.delete(`/admin/products/${productId}`);

export const adminGetOrders = () => api.get('/admin/orders');

export const adminUpdateOrderStatus = (orderId, status) => 
  api.put(`/admin/orders/${orderId}/status`, { status });

export const adminGetStats = () => api.get('/admin/stats');

export const adminGetNotifications = (params = {}) => api.get('/admin/notifications', { params });
export const adminGetUnreadCount = () => api.get('/admin/notifications/unread-count');
export const adminMarkNotificationRead = (id) => api.put(`/admin/notifications/${id}/read`);
export const adminMarkAllNotificationsRead = () => api.put('/admin/notifications/read-all');
export const adminDeleteNotification = (id) => api.delete(`/admin/notifications/${id}`);
export const adminMarkPaymentFailed = (orderId, reason) =>
  api.post(`/admin/orders/${orderId}/payment-failed`, { reason });

export const adminUploadProductImage = (productId, file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post(`/admin/products/${productId}/image`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const adminBulkUploadProductImages = (filesByProductId) => {
  // filesByProductId: { productId: File }
  const fd = new FormData();
  Object.entries(filesByProductId).forEach(([productId, file]) => {
    const ext = file.name.split('.').pop() || 'jpg';
    const renamed = new File([file], `${productId}.${ext}`, { type: file.type });
    fd.append('files', renamed);
  });
  return api.post('/admin/products/bulk-images', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export default api;
